import config from '@config';
import merge from 'lodash/merge';

const fontFamily = 'FedraSansStd-medium';

const commonLangStyle = ({ lang, ...props }) => {
  const isIndian = config.indianLang.indexOf(lang) > -1;
  const styleObj = {
    makingText: {
      fontSize: { base: '32px', lg: '32px' },
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontWeight: 500,
      lineHeight: { base: '28.8px', lg: '28px' },
      color: '#fff',
    },
    miracleText: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Trirong',
      fontStyle: 'italic',
      fontWeight: 500,
      fontSize: { base: '64px', lg: '72px' },
      lineHeight: { base: '57.6px', lg: '64px' },
      color: '#EC1C2D',
      letterSpacing: '-1.44px',
    },
    ofMindText: {
      fontSize: { base: '40px', md: '48px' },
      lineHeight: { base: '36px', md: '50px' },
      letterSpacing: '-0.96px',
      fontWeight: 500,
      fontFamily: isIndian ? config.momLangFont[lang] : 'Trirong',
      color: '#fff',
    },
  };

  const finalObj = merge(styleObj, { ...props });
  return finalObj;
};

const MakingMiracleSt = {
  en: commonLangStyle({ lang: 'en' }),
  bn: commonLangStyle({ lang: 'bn' }),
  hi: commonLangStyle({
    lang: 'hi',
  }),
  te: commonLangStyle({ 
    lang: 'te',
    makingText: {
      ...commonLangStyle({ lang: 'te' }).makingText,
      fontSize: { base: '32px', md: '48px' },
      lineHeight: { base: '35px', md: '52px' },
    },
    miracleText: {
      ...commonLangStyle({ lang: 'te' }).miracleText,
      fontSize: { base: '64px', lg: '72px' },
      lineHeight: { base: '88px', lg: '96px' },
    },
  }),
  kn: commonLangStyle({ lang: 'kn' }),
  gu: commonLangStyle({ lang: 'gu' }),
  mr: commonLangStyle({ lang: 'mr' }),
  ml: commonLangStyle({ lang: 'ml' }),
  'zh-tw': commonLangStyle({ lang: 'zh-tw' }),
  zh: commonLangStyle({ lang: 'zh' }),
  it: commonLangStyle({ lang: 'it' }),
  fr: commonLangStyle({ lang: 'fr' }),
  de: commonLangStyle({ lang: 'de' }),
  es: commonLangStyle({ lang: 'es' }),
  ru: commonLangStyle({ lang: 'ru' }),
  ta: commonLangStyle({
    lang: 'ta',
    makingText: {
      ...commonLangStyle({ lang: 'ta' }).makingText,
      fontSize: { base: '32px', md: '48px' },
      lineHeight: { base: '35px', md: '52px' },
    },
    miracleText: {
      ...commonLangStyle({ lang: 'ta' }).miracleText,
      fontSize: { base: '32px', md: '48px', lg: '48px' },
      lineHeight: { base: '35px', md: '52px' },
    },
    ofMindText: {
      ...commonLangStyle({ lang: 'ta' }).ofMindText,
      fontSize: { base: '32px', md: '48px' },
      lineHeight: { base: '35px', md: '52px' },
    },
  }),
  cn: commonLangStyle({ lang: 'cn' }),
  ar: commonLangStyle({
    lang: 'ar',
  }),
  id: commonLangStyle({ lang: 'id' }),
};
export default MakingMiracleSt;
